"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var shallowEqual = require("shallowequal");
function composeReducers() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var reducers = args;
    var options = {};
    if (typeof args[args.length - 1] === 'object') {
        reducers = args.slice(0, -1);
        options = tslib_1.__assign({}, options, args[args.length - 1]);
    }
    var _a = options.equalityCheck, equalityCheck = _a === void 0 ? shallowEqual : _a;
    return function (state, action) {
        var newState = lodash_1.flowRight(reducers.map(function (reducer) { return lodash_1.curryRight(reducer, 2)(action); }))(state);
        return equalityCheck(state, newState) ? state : newState;
    };
}
exports.default = composeReducers;
//# sourceMappingURL=compose-reducers.js.map